import React from 'react';
import PropTypes from 'prop-types';
import { get, set } from '@totalsoft/change-tracking-react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Grid, Checkbox } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { isValid } from '@totalsoft/pure-validations-react';
import { Close, Check } from '@mui/icons-material';
import PropertySelector from 'features/common/components/property-selector/PropertySelector';

const FinancialProductPropertiesTableRow = ({ canWrite, dataLens, properties, index, onCancelEdit, onDelete, onSave, validation }) => {
  const [t] = useTranslation();
  const data = dataLens |> get;
  return (
    <TableRow>
      {data.isInEditing ? (
        <>
          <PropertySelector
            required={{ property: true, value: true }}
            lens={dataLens}
            properties={properties}
            validation={validation[index]}
            container={TableCell}
          />
          <TableCell>
            <Checkbox disabled={!canWrite} checked={data.mandatory || false} onChange={() => set(dataLens.mandatory)(!data.mandatory)} />
          </TableCell>
          <TableCell align='right'>
            <Grid container wrap='nowrap' justifyContent='flex-end'>
              <IconButton
                type='save'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Save')}
                disabled={data.isSaving || !canWrite || !isValid(validation[index]) || !isValid(validation)}
                onClick={() => onSave(index)}
              />
              <IconButton
                type='cancel'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.CloseEdit')}
                onClick={() => onCancelEdit(data.leasingFinancialProductPropertyId, index)}
              />
              <IconButton
                type='delete'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Delete')}
                onClick={() => onDelete(data.leasingFinancialProductPropertyId, index)}
                disabled={!canWrite}
              />
            </Grid>
          </TableCell>
        </>
      ) : (
        <>
          <TableCell>{data.propertyName}</TableCell>
          <TableCell>{data.propertyValue}</TableCell>
          <TableCell>
            <>{data.mandatory === true ? <Check color='success' /> : <Close />}</>
          </TableCell>
          <TableCell align='right'>
            <Grid container wrap='nowrap' justifyContent='flex-end'>
              <IconButton
                type='edit'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Edit')}
                onClick={() => set(dataLens.isInEditing)(true)}
                disabled={!canWrite}
              />
              <IconButton
                type='delete'
                fontSize='medium'
                color='transparent'
                tooltip={t('FinancialProduct.Delete')}
                onClick={() => onDelete(data.leasingFinancialProductPropertyId, index)}
                disabled={!canWrite}
              />
            </Grid>
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

FinancialProductPropertiesTableRow.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  dataLens: PropTypes.object,
  properties: PropTypes.array,
  index: PropTypes.number,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductPropertiesTableRow;
